.spinner {
  border-radius: 50%;
  animation: spin var(--duration-spinner) linear infinite;
  flex-shrink: 0;
}

.size-sm {
  inline-size: var(--size-20);
  block-size: var(--size-20);
  border: var(--tds-stroke-weight-standard) solid var(--tds-color-stroke-strong);
  border-block-start-color: currentColor;
}

.size-md {
  inline-size: var(--size-32);
  block-size: var(--size-32);
  border: var(--tds-stroke-weight-highlight) solid
    var(--tds-color-stroke-subtle);
  border-block-start-color: var(--tds-color-surface-brand-default);
}

.size-lg {
  inline-size: 3em; /* 48px equivalent */
  block-size: 3em; /* 48px equivalent */
  border: var(--tds-stroke-weight-highlight) solid
    var(--tds-color-stroke-subtle);
  border-block-start-color: var(--tds-color-surface-brand-default);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
